<template>
  <div :id="getId" class="address-lookup">
    <h4>
      {{ this.title }}
    </h4>
    <div class="form-group">
      <label for="address" class="form-label">Address</label>
      <input class="form-control" v-model="location.address" id="address"/>
    </div>
    <div class="form-group">
      <label for="street" class="form-label">Street</label>
      <input class="form-control" v-model="location.street" id="street"/>
    </div>
    <div class="form-group">
      <label class="form-label">Town</label>
      <autocomplete
        :styles="{ input: { background: 'none', color: '#fff' } }"
        :dataset="locationSearchResults"
        :initVal="initialLocation"
        v-on:changing="data => locationSearch = data"
        :fnFormatText="locationFormat"
        :fnSelectValue="locationFormat"
        v-on:selection-made="updateLocation"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label for="county" class="form-label">County</label>
      <input class="form-control" v-model="location.county" id="county"/>
    </div>
    <div class="form-group">
      <label for="state" class="form-label">State</label>
      <input class="form-control" v-model="location.subdivision" id="state"/>
    </div>
    <div class="form-group">
      <label for="postcode" class="form-label">Post code</label>
      <input class="form-control" v-model="location.postCode" id="postcode"/>
    </div>
    <div class="form-group">
      <label for="country" class="form-label">Country</label>
      <input class="form-control" v-model="location.country"  id="country"/>
    </div>
    <div class="text-center">
      <div  class="btn btn-primary sq" @click="save">
        Save
      </div>
      <div  class="btn btn-danger sq" @click="cancel">
        Cancel
      </div>
    </div>
  </div>
</template>
<script>
  import Autocomplete from '../modules/helpers/AutoComplete.vue'
  import VueScrollTo from 'vue-scrollto'
  import event from '../event'
  import API from '../api/endpoints'
  export default {
    name: 'LocationLookup',
    components: {
      Autocomplete
    },
    props: ['title', 'initData', 'event', 'callerId', 'isOpen'],
    data () {
      return {
        location: {
          address: '',
          street: '',
          location: '',
          county: '',
          subdivision: '',
          postCode: '',
          country: ''
        },
        initialLocation: {},
        locationSearchResults: [],
        locationSearch: ''
      }
    },
    watch: {
      locationSearch (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updateLocationSearchResults(newVal)
        } else {
          this.locationSearchResults = []
        }
      }
    },
    computed: {
      getId () {
        return 'loc-lookup-' + this._uid
      },
      countries () {
        return this.$store.getters['systemOption/countries']
      }
    },
    methods: {
      locationFormat (location) {
        let str = ''
        if (location.name) {
          str += location.name
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      save () {
        event.$emit(this.event, {
          callerId: this.callerId,
          data: this.location
        })
        event.$emit('right-close-and-destroy')
        this.$destroy()
      },
      cancel () {
        event.$emit('right-close-and-destroy')
        this.$destroy()
      },
      updateLocationSearchResults (str) {
        this.$http.get(API.GET_LOCATIONS_NAME_LIKE(str))
          .then(({data}) => {
            if (str === this.locationSearch) {
              this.$store.dispatch('quote/mapLocationsWithCountry', data)
              .then(res => {
                this.locationSearchResults = res
              })
              .catch(err => {
                console.log(err)
                this.locationSearchResults = data
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      updateLocation (loc) {
        this.location.location = loc
        this.locationSearchResults = []
        this.locationSearch = ''
      }
    },
    mounted () {
      for (let prop in this.initData) {
        if (this.location.hasOwnProperty(prop)) {
          this.location[prop] = this.initData[prop]
        }
      }
      this.initialLocation = this.initData.location
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LocationLookup.vue